import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class PullDataService extends ApiService {
  static pathName = '/pull-data';

  static getWorksheetData = (body: {
    googleAccessToken: string;
    spreadsheetId: string;
    rangeFilter: string;
    sheets: number;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/get-worksheet-data`, body);
  };

  static getGoogleSlidesData = (body: {
    googleAccessToken: string;
    presentationId: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/get-presentation-data`, body);
  };
}
